'use strict';

$(document).ready(function () {
  $('.svg-img').on('click', function (e) {
    var currentElement= $(this).closest('.tec-container').find('.yt_video_link');
    var video_id = currentElement.data('ytid').split('v=')[1];

    e.preventDefault();
    var div_id = currentElement.attr('id');
    var div_iframe = currentElement.find('img').attr('id');  
    currentElement.find('#'+div_id +' .yt_video_play').css('display', 'none');
    $(this).css('display', 'none');
   
    onYouTubeIframeAPIReady(video_id, div_iframe, 560, 315);

  });
  var tag = document.createElement('script');
  var player;
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

function onYouTubeIframeAPIReady(yt_id, iframe_id, iframe_width, iframe_height) {

  player = new YT.Player(iframe_id, {
    width: iframe_width,
    height: iframe_height,
    videoId: yt_id,
    playerVars: {
      'autoplay': 1,
      'playsinline': 1
    },
    events: {
      'onReady': onPlayerReady
    }
  });
}

function onPlayerReady(event) {
  //event.target.mute();
  event.target.setVolume(70);
  event.target.playVideo();
}
});